import { HistoricalVisit } from '@dreryk/egabinet-visit-frontend-api';

import {
   SidePanelContentSlot,
   SidePanelContentSlotProps,
   SidePanelList,
   StethoscopeIcon,
} from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.visit';

import { historicalVisitsTranslationKeys, historicalVisitTranslationKeys } from '../../translations';
import { SidePanelLoader } from '../SidePanelLoader';

import { HistoricalVisitContentSlotHeader } from './HistoricalVisitContentSlotHeader';
import { useHistoricalVisitItems } from './historicalVisits.hooks';

type HistoricalVisitContentSlotProps = {
   readonly onGoBackLinkClick: VoidFunction;
   readonly historicalVisit?: HistoricalVisit;
   readonly isLoading: boolean;
   readonly subHeader?: SidePanelContentSlotProps['subHeader'];
   readonly targetVisitId: number;
   readonly patientId: number;
   readonly visitDiagnoses: VisitDiagnoses;
};

export const HistoricalVisitContentSlot = (props: HistoricalVisitContentSlotProps): JSX.Element => {
   const items = useHistoricalVisitItems(
      props.historicalVisit,
      props.targetVisitId,
      props.patientId,
      props.visitDiagnoses
   );

   return (
      <SidePanelContentSlot
         headerText={
            props.historicalVisit ? (
               <HistoricalVisitContentSlotHeader
                  author={props.historicalVisit.createdBy}
                  visitDate={props.historicalVisit.date}
               />
            ) : (
               historicalVisitTranslationKeys.loading
            )
         }
         goBackLinkLabel={historicalVisitsTranslationKeys.historicalVisit.goBackToList}
         onGoBackLinkClick={props.onGoBackLinkClick}
         subHeader={props.subHeader}
      >
         {props.isLoading ? (
            <SidePanelLoader />
         ) : (
            <SidePanelList
               icon={<StethoscopeIcon />}
               items={items}
               noItemsMessage={historicalVisitTranslationKeys.noVisitData}
            />
         )}
      </SidePanelContentSlot>
   );
};
